<template>
  <div>
    <div class="activationCode">
      <v-container style="padding-top: 0; padding-bottom: 0;">
        <v-col
          cols="12"
          sm="10"
          offset-sm="1"
          style="padding-top: 0; padding-bottom: 0;"
        >
          <div class="activationCodeForm">
            <h2 class="text-center sec-title">{{ $t("reAssignPassword") }}</h2>
            <p class="desc" v-if="verificationCodeSent">
              {{ $t("verficationCodeSent") }}
            </p>
            <!-- <p class="desc" v-else>
              برجاء كتابة بريدك الالكترونى لاعادة تعيين كلمة المرور.
            </p>-->
            <v-row>
              <v-col cols="12" sm="8" offset-sm="2">
                <v-form v-model="valid" ref="form">
                  <div
                    :style="
                      verificationCodeSent || canChangePassword
                        ? 'display:none'
                        : 'display:block'
                    "
                  >
                    <label for="activationCode">{{ $t("email") }}</label>
                    <v-text-field
                      solo
                      :rules="[validationRules.required, validationRules.email]"
                      v-model="user.email"
                    ></v-text-field>
                  </div>
                  <div v-if="verificationCodeSent">
                    <label for="activationCode"
                      >{{ $t("verificationCode") }}
                    </label>
                    <v-text-field
                      solo
                      :rules="[validationRules.required]"
                      v-model="user.verification_code"
                    ></v-text-field>
                  </div>
                  <div v-if="canChangePassword">
                    <label for="activationCode">{{ $t("newPassword") }}</label>
                    <v-text-field
                      :append-icon="togglePassword ? 'mdi-eye-off' : 'mdi-eye'"
                      @click:append="() => (togglePassword = !togglePassword)"
                      :type="togglePassword ? 'password' : 'text'"
                      solo
                      :rules="[
                        validationRules.required,
                        validationRules.password
                      ]"
                      v-model="user.password"
                      class="password"
                    ></v-text-field>

                    <label for="activationCode">{{
                      $t("reEnterPassword")
                    }}</label>
                    <v-text-field
                      :append-icon="togglePassword ? 'mdi-eye-off' : 'mdi-eye'"
                      @click:append="() => (togglePassword = !togglePassword)"
                      :type="togglePassword ? 'password' : 'text'"
                      solo
                      :rules="[
                        validationRules.required,
                        validationRules.password
                      ]"
                      v-model="user.password_conf"
                      class="password"
                    ></v-text-field>
                  </div>
                  <v-btn
                    class="primary-btn"
                    @click="resetPassword"
                    :loading="loading"
                    :disabled="loading"
                    large
                    >{{ $t("Follow") }}</v-btn
                  >
                </v-form>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-container>
    </div>
    <Snack ref="snack"></Snack>
  </div>
</template>

<script>
import { validationMixin } from "../../mixins/validationMixin";
export default {
  name: "ForgotPassword",
  mixins: [validationMixin],

  data() {
    return {
      togglePassword: true,
      loading: false,
      user: {
        email: "",
        verification_code: "",
        password: "",
        password_conf: ""
      },
      verificationCodeSent: false,
      canChangePassword: false,
      valid: false
    };
  },

  methods: {
    resetPassword() {
      if (this.canChangePassword) {
        if (this.valid == false) {
          this.validate();
        } else {
          this.loading = true;
          this.$http
            .post(this.getApiUrl + "/user/changepassword", this.user, {
              headers: {
                locale: localStorage.locale
              }
            })
            .then(Response => {
              this.loading = false;
              if (Response.data.status.error) {
                this.$refs.snack.sendErrorAlert(Response.data.status.message);
              } else {
                this.$router.push({ path: "/login?password_changed=success" });
              }
            });
        }
      } else if (this.verificationCodeSent == false) {
        if (this.valid == false) {
          this.validate();
        } else {
          this.$http
            .post(this.getApiUrl + "/user/password/forget", this.user, {
              headers: {
                locale: localStorage.locale
              }
            })
            .then(Response => {
              if (Response.data.status.error) {
                this.$refs.snack.sendErrorAlert(Response.data.status.message);
              } else {
                this.verificationCodeSent = true;
              }
            });
        }
      } else {
        if (this.valid == false) {
          this.validate();
        } else {
          this.$http
            .post(this.getApiUrl + "/verify", this.user, {
              headers: {
                locale: localStorage.locale
              }
            })
            .then(Response => {
              if (Response.data.status.error) {
                this.$refs.snack.sendErrorAlert(Response.data.status.message);
              } else {
                this.canChangePassword = true;
                this.verificationCodeSent = false;
              }
            });
        }
      }
    }
  },
  mounted() {
    console.log("");
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/_variables.scss";
@import "../../assets/styles/_responsive.scss";

.activationCode {
  min-height: 91vh;
  background-image: url("../../assets/images/background.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  background-attachment: scroll !important;
  position: relative;
  //   padding-top: $padding-top;

  .activationCodeForm {
    min-height: 91vh;
    padding-top: 10%;
    padding-bottom: $padding-bottom;
    background-color: $background-overlay;
    position: relative;
    padding-left: 1rem;
    padding-right: 1rem;
    h2 {
      color: $second-color;
    }
    .desc {
      color: $second-color;
      text-align: center;
      margin: 0 auto;
    }
    @media (min-width: 600px) {
      .desc {
        max-width: 50%;
      }
    }
    .primary-btn {
      width: 100%;
      background-color: $second-color !important;
    }
  }
}

label {
  color: $second-color;
}
</style>
